module.exports = __webpack_public_path__ + "static/media/worry-free-7.cee5d04d.png";